import React from "react";
import { KeyboardAvoidingView, Platform, StyleSheet, TextInput, TextInputProps, Text, TextInputSubmitEditingEvent, TextStyle, View } from "react-native";
import InputsConfig from "../../Config/inputs"
import { SText, STheme, SUuid } from "servisofts-component2";
import InputTypes from "./InputTypes";

type inputTypes = {
    type?: "text"
} | {
    type: "password"
} | {
    type: "select",
    options: any[],

} | {
    type: "number"
}


export type InputProps = {
    name?: string,
    style?: TextStyle | TextStyle[],
    placeholder?: string,
    value?: string,
    defaultValue?: string,
    autoFocus?: boolean,
    required?: boolean,
    textContentType?: TextInputProps["textContentType"],
    autoComplete?: TextInputProps["autoComplete"],
    onChangeText?: (text: string) => void,
    onSubmitEditing?: (e: TextInputSubmitEditingEvent) => void,
    clean?: boolean,
    keyboardType?: TextInputProps["keyboardType"],

} & inputTypes;


type EventsInputs = "onChangeText" | "onFocus" | "onBlur" | "onKeyPress" | "onSubmitEditing" | "componentDidMount" | "componentWillUnmount";



export default class Input extends React.Component<InputProps> {


    key: string = SUuid();
    textInput: TextInput | null = null;
    state = {
        value: this.props.value || this.props.defaultValue || "",
        error: "",
        textWidth: 0,
        errorDescription: "",
    }
    style: TextStyle | TextStyle[] = {};
    _ref: any = {}
    _listeners: { [key in EventsInputs]?: ((...args: any[]) => void)[] } = {};

    _ElementFooter: React.ReactNode | null = null;
    addEventListener(event: EventsInputs, callback: (...args: any[]) => void) {
        if (!this._listeners[event]) {
            this._listeners[event] = [];
        }
        this._listeners[event]?.push(callback);
        return callback;
    }
    removeEventListener(event: EventsInputs, callback: (...args: any[]) => void) {
        if (!this._listeners[event]) return;
        this._listeners[event] = this._listeners[event]?.filter(cb => cb !== callback);
    }

    dispatchEvent(event: EventsInputs, ...args: any[]) {
        if (!this._listeners[event]) return;
        this._listeners[event]?.forEach(callback => {
            try {
                callback(...args);
            } catch (e) {
                console.error("Error in Input event listener:", e);
            }
        });
    }


    componentDidMount(): void {
        this.dispatchEvent("componentDidMount");

    }

    componentWillUnmount(): void {
        this.dispatchEvent("componentWillUnmount");

    }
    getValue() {
        return this.state.value;
    }
    setValue(value: string) {
        this.state.value = value;
        this.handleChangeText(value);
    }

    focus() {
        if (this.textInput) {
            this.textInput.focus();
        }
    }

    handleChangeText = (text: string) => {
        this.setState({ value: text });
        this.dispatchEvent("onChangeText", text);
        if (this.props.onChangeText) {
            this.props.onChangeText(text);
        }
    }

    validar__ = () => {
        let props = this.props;
        if (this.state.value.trim() === '') {
            this.setState({ error: true });
            return false;
        } else {
            this.setState({ error: false });
            return true;
        }

        // if (props.required && !this.state.value.trim()) {
        //     this.setState({ error: true, errorDescription: "Este campo es requerido." });
        //     return false;
        // }
        // this.setState({ error: false, errorDescription: "" });
        // return true;
    };

    validar = () => {
        let props = this.props;
        console.log("validar", this.state.value);
        console.log("props", props);

        if (props.required && !this.state.value.trim() ) {
            // this.setState({ error: true, errorDescription: "Este campo es requerido." });
            this.setState({ error: true });
            return false;
        }
        if(props.type === "number" && isNaN(Number(this.state.value))){
            console.log("no es numero")
            this.setState({ error: true, errorDescription: "El valor debe ser numérico." });
            return false;
        }
        this.setState({ error: false, errorDescription: "" });
        return true;
    };



    buildPropsByType() {
        let props = this.props;
        let type = (props.type || "text") as keyof typeof InputTypes;
        if (InputTypes[type]) {
            return InputTypes[type](this);
        }
        return InputTypes.text(this);
        // switch (props.type) {
        //     case "password":
        //         return InputTypes.password(this);
        //     case "text":
        //     default:

        // }
    }

    handleOnSubmitEditing = (e: TextInputSubmitEditingEvent) => {
        this.dispatchEvent("onSubmitEditing", e);
        if (this.props.onSubmitEditing) {
            this.props.onSubmitEditing(e);
        }

    }
    render() {
        let placeholderTextColor = InputsConfig().default.InputText.placeholderTextColor || STheme.color.lightGray;

        if (!this.props.clean) {
            placeholderTextColor = InputsConfig().default.InputText.placeholderTextColor || STheme.color.lightGray;
        }

        this.style = this.props?.style ?? [];
        const props: any = this.buildPropsByType();
        return <>
            {/* {Platform.OS === "web" && ( */}
            <Text
                style={[InputsConfig().default.InputText, this.style, this.state.error && InputsConfig().default.error, styles.hiddenText]}
                onLayout={(e) => {
                    // this.state.textWidth = e.nativeEvent.layout.width; // margen adicional
                    this.setState({ textWidth: e.nativeEvent.layout.width + 10 });
                    // setTextWidth(e.nativeEvent.layout.width); // margen adicional
                }}
            >
                {this.state.value || props.placeholder || ""} {/* Para que el TextInputResize pueda calcular el ancho */}
            </Text>
            {/* )} */}
            <TextInput
                ref={(ref: any) => {
                    this.textInput = ref;
                }}
                value={this.state.value}
                autoCorrect={false}
                {...props}
                // multiline

                style={[
                    { maxWidth: "100%", width: this.state?.textWidth || 0, outlineWidth: 0},
                    InputsConfig().default.InputText,
                    this.style,
                    this.state.error && InputsConfig().default.error,
                ]}
                placeholderTextColor={placeholderTextColor}
                onChangeText={this.handleChangeText.bind(this)}
                onSubmitEditing={this.handleOnSubmitEditing.bind(this)}
            />
            <SText color={STheme.color.danger}>{this.state.error}</SText>
            <SText color={STheme.color.danger}>{this.state.errorDescription}</SText>
            {this._ElementFooter}
        </>
    }
}

const styles = StyleSheet.create({

    hiddenText: {
        position: "absolute",
        opacity: 0,
        pointerEvents: "none",
        fontSize: 16,
        ...Platform.select({
            web: {
                whiteSpace: "pre",
            },
        }),
    },
});
